<template>
  <div>
    <el-dialog
      title="配置日志详情"
      width="820px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        max-height="420"
        :header-cell-style="{ background: '#F5F6F7' }"
      >
        <el-table-column label="配置下发ID" prop="configPublishId" min-width="120"></el-table-column>
        <el-table-column label="下发类型" prop="publishTypeDescription" min-width="120"></el-table-column>
        <el-table-column label="下发结果" prop="publishCode" min-width="180"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" min-width="160"></el-table-column>
        <el-table-column label="更新时间" prop="updateTime" min-width="160"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { postPublishLogDetail } from '@/api/device/log'

export default {
  name: 'configurationLogDetailDialog',
  data() {
    return {
      dialogVisible: false,
      configPublishId: '',
      tableData: [],
      loading: false
    }
  },
  methods: {
    init(row) {
      this.configPublishId = row?.id || ''
      this.dialogVisible = true
      this.queryDetail()
    },
    async queryDetail() {
      if (!this.configPublishId) return
      this.loading = true
      try {
        const res = await postPublishLogDetail({
          configPublishId: this.configPublishId
        })
        this.tableData = res.data?.data || []
      } catch (e) {
        this.$message.error('查询配置日志详情失败，请重试')
        console.error('查询配置日志详情失败：', e)
      } finally {
        this.loading = false
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.configPublishId = ''
      this.tableData = []
    }
  }
}
</script>
<style scoped lang="scss">

</style>
